module.exports = __webpack_public_path__ + "img/concept-art-part-2.a2e36452.png";